import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss'],
})
export class BulkUploadComponent implements OnInit, OnChanges, OnDestroy {
  private _unsubscribe = new Subject<void>();

  @ViewChild('f', { static: true }) fileInputForm: NgForm;

  @Input() isUploading: boolean = false;
  @Input() uploadedFiles: IFilesList[] = [];
  @Input() fileType: any;

  @Output() filesToUpload = new EventEmitter<IFilesList[]>();
  @Output() formValidate = new EventEmitter<boolean>();

  filesListToUpload: IFilesList[] = [];
  formValidity: boolean;
  nameInput: string = '';

  constructor() {}

  ngOnInit(): void {
    this.fileInputForm.valueChanges
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(() => {
        this.formValidity = this.fileInputForm.valid;
        if (!this.formValidity) {
          this.formValidate.emit(this.formValidity);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.uploadedFiles && changes.uploadedFiles.currentValue) {
      this.filesListToUpload = changes.uploadedFiles.currentValue;
    }
    console.log('uploaded files: ', this.uploadedFiles);
  }

  onFileUpload(): void {
    const inputValueObj = this.fileInputForm.value;
    const names = Object.keys(inputValueObj).map((key) => inputValueObj[key]);
    names.forEach((name: string, i: number) => {
      this.filesListToUpload[i].name = name;
    });
    this.filesToUpload.emit(this.filesListToUpload.slice());
    this.formValidate.emit(this.formValidity);
  }

  onFileDeselect(index: number): void {
    this.filesListToUpload.splice(index, 1);
  }

  onFileSelect(event: Event): void {
    this.filesListToUpload = [];
    const filesList = (event.target as HTMLInputElement).files;
    if (!filesList) return;
    this.constructFilesListToUpload(filesList);
  }

  constructFilesListToUpload(filesList: FileList): void {
    Array.from(filesList).forEach((item: File) => {
      const newFile: IFilesList = {
        file: item,
        url: '',
        name: '',
        uploadStatus: {
          isSuccess: false,
          isError: false,
          errorMessage: '',
        },
      };
      this.filesListToUpload.push(newFile);
    });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}

export interface IFilesList {
  file: File;
  url: string;
  name: string;
  uploadStatus: {
    isSuccess: boolean;
    isError: boolean;
    errorMessage: string;
  };
}
